<div [ngSwitch]="aWidgetParams.type">
  <div *ngSwitchCase="'contactus'">
    <wgt-contactus [aWidgetParams]="aWidgetParams"></wgt-contactus>
  </div>
  <div *ngSwitchCase="'carousel'">
    <wgt-carousel [aWidgetParams]="aWidgetParams"></wgt-carousel>
  </div>
</div>